import { Button, Modal } from "react-bootstrap";
import { connect } from "react-redux";

function EndExerciseConfirmModal({
  isOpen,
  onClose,
  onRepeatCircuit,
  onCompleteExercise,
  activeCircuit,
  isCircuitIncrementInProgress,
}) {
  const isExerciseFinished = activeCircuit > 3;

  const circuitCount = isExerciseFinished ? 3 : activeCircuit - 1;

  return (
    <Modal
      show={isOpen}
      onHide={onClose}
      id="end-exercise-confirm-modal"
      className="workout-modal"
      centered
      size="lg"
      backdrop="static"
    >
      <div hidden={!isCircuitIncrementInProgress} className="modal-background p-4 text-center">
        <h4>
          <strong>Processing...</strong>
        </h4>
        <p className="mt-3">We're updating your progress!</p>
      </div>
      <div hidden={isCircuitIncrementInProgress} className="modal-background p-4 text-center">
        <h4>
          <strong>Set {circuitCount} of 3 complete!</strong>
        </h4>
        {!isExerciseFinished ? (
          <p className="mt-3">Would you like to repeat the circuit?</p>
        ) : (
          <p className="mt-3">Congratulations, you've finished the workout!</p>
        )}
        <div className="d-flex justify-content-center gap-3 mt-4">
          <Button
            hidden={isExerciseFinished}
            variant="danger"
            className="custom-btn"
            onClick={onRepeatCircuit}
          >
            <div>
              <strong>Yes</strong>
            </div>
            <small>Continue</small>
          </Button>
          <Button
            variant="dark"
            className="custom-btn"
            onClick={onCompleteExercise}
          >
            <div hidden={isExerciseFinished}>
              <strong>No</strong>
            </div>
            <small>End Workout</small>
          </Button>
        </div>
      </div>
    </Modal>
  );
}

const mapStateToProps = (state) => ({
  activeCircuit: state.userActiveDayReducer.activeDay?.circuit,
  isCircuitIncrementInProgress: state.userActiveDayReducer.isCircuitIncreamentInProgress,
});

export default connect(mapStateToProps, null)(EndExerciseConfirmModal);